// One event per color with and without resource

export const defaultVisibleDate = new Date('2025-07-01T00:00:00');

export const initialEventsWithResources = [
  {
    id: 'purple',
    start: '2025-07-02T00:00:00',
    end: '2025-07-02T00:00:00',
    allDay: true,
    title: 'purple',
    resource: 'purple',
  },
  {
    id: 'teal',
    start: '2025-07-02T00:00:00',
    end: '2025-07-02T00:00:00',
    allDay: true,
    title: 'teal',
    resource: 'teal',
  },
  {
    id: 'lime',
    start: '2025-07-02T00:00:00',
    end: '2025-07-02T00:00:00',
    allDay: true,
    title: 'lime',
    resource: 'lime',
  },
  {
    id: 'orange',
    start: '2025-07-02T00:00:00',
    end: '2025-07-02T00:00:00',
    allDay: true,
    title: 'orange',
    resource: 'orange',
  },
  {
    id: 'green',
    start: '2025-07-02T00:00:00',
    end: '2025-07-02T00:00:00',
    allDay: true,
    title: 'green',
    resource: 'green',
  },
  {
    id: 'pink',
    start: '2025-07-02T00:00:00',
    end: '2025-07-02T00:00:00',
    allDay: true,
    title: 'pink',
    resource: 'pink',
  },
  {
    id: 'indigo',
    start: '2025-07-02T00:00:00',
    end: '2025-07-02T00:00:00',
    allDay: true,
    title: 'indigo',
    resource: 'indigo',
  },
  {
    id: 'amber',
    start: '2025-07-02T00:00:00',
    end: '2025-07-02T00:00:00',
    allDay: true,
    title: 'amber',
    resource: 'amber',
  },
  {
    id: 'blue',
    start: '2025-07-02T00:00:00',
    end: '2025-07-02T00:00:00',
    allDay: true,
    title: 'blue',
    resource: 'blue',
  },
];

export const initialEventsWithoutResources = [
  {
    id: 'purple',
    start: '2025-07-02T00:00:00',
    end: '2025-07-02T00:00:00',
    allDay: true,
    title: 'purple',
    color: 'purple',
    resource: 'a',
  },
  {
    id: 'teal',
    start: '2025-07-03T00:00:00',
    end: '2025-07-03T00:00:00',
    allDay: true,
    title: 'teal',
    color: 'teal',
    resource: 'a',
  },
  {
    id: 'lime',
    start: '2025-07-04T00:00:00',
    end: '2025-07-04T00:00:00',
    allDay: true,
    title: 'lime',
    color: 'lime',
    resource: 'a',
  },
  {
    id: 'orange',
    start: '2025-07-02T00:00:00',
    end: '2025-07-02T00:00:00',
    allDay: true,
    title: 'orange',
    color: 'orange',
    resource: 'b',
  },
  {
    id: 'green',
    start: '2025-07-03T00:00:00',
    end: '2025-07-03T00:00:00',
    allDay: true,
    title: 'green',
    color: 'green',
    resource: 'b',
  },
  {
    id: 'pink',
    start: '2025-07-04T00:00:00',
    end: '2025-07-04T00:00:00',
    allDay: true,
    title: 'pink',
    color: 'pink',
    resource: 'b',
  },
  {
    id: 'indigo',
    start: '2025-07-02T00:00:00',
    end: '2025-07-02T00:00:00',
    allDay: true,
    title: 'indigo',
    color: 'indigo',
    resource: 'c',
  },
  {
    id: 'amber',
    start: '2025-07-03T00:00:00',
    end: '2025-07-03T00:00:00',
    allDay: true,
    title: 'amber',
    color: 'amber',
    resource: 'c',
  },
  {
    id: 'blue',
    start: '2025-07-04T00:00:00',
    end: '2025-07-04T00:00:00',
    allDay: true,
    title: 'blue',
    color: 'blue',
    resource: 'c',
  },
];

export const resourcesWithoutColors = [
  { title: 'Resource A', id: 'a' },
  { title: 'Resource B', id: 'b' },
  { title: 'Resource C', id: 'c' },
];

export const resourcesWithColors = [
  { title: 'purple', id: 'purple', eventColor: 'purple' },
  { title: 'teal', id: 'teal', eventColor: 'teal' },
  { title: 'lime', id: 'lime', eventColor: 'lime' },
  { title: 'orange', id: 'orange', eventColor: 'orange' },
  { title: 'green', id: 'green', eventColor: 'green' },
  { title: 'pink', id: 'pink', eventColor: 'pink' },
  { title: 'indigo', id: 'indigo', eventColor: 'indigo' },
  { title: 'amber', id: 'amber', eventColor: 'amber' },
  { title: 'blue', id: 'blue', eventColor: 'blue' },
];
